
import { useEffect, useState } from "react";
import axios from "axios";
import { errorHandeling } from "../../errorHandeling";
import { useSelector } from "react-redux";
import apiUrl from "../../libs/baseUrl";
import usePermissions from "../../customHooks/usePermissions";

import MainPageNotifiEvalStart from "../MainPageNotifiEvalStart/MainPageNotifiEvalStart";

import "./showEvalResponsableEmpStartNotif.scss";

function ShowEvalResponsableEmpStartNotif() {

const token = useSelector(state => state.user.token);

const { checkPermissionAndThrow } = usePermissions();
  
//====State start here====    
    
   //to show the evaluation nofication
   const [evalNotifiSemiAnnualStart,setEvalNotifiSemiAnnualStart] = useState(false);

   const [evalNotifiDirectManagerStart,setEvalNotifiDirectManagerStart] = useState(false);
  
   const [error,setError] = useState('');

//====State end here====   

//====Event handler start here====
  //fetch the the records for the statistcs status
  const fetchEvalStatStatus = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/users/evaluation-users/all`,
     
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      setEvalNotifiSemiAnnualStart(response.data?.data?.SEMI_ANNUAL);

      setEvalNotifiDirectManagerStart(response.data?.data?.manager_evaluation);

 
    } catch (error) {
      console.error('Error:', error);
      setError(errorHandeling(error.message))
  
    }

  
  };  
//====Event handler end here====


//====useEffect start here====
  useEffect(()=>{
    fetchEvalStatStatus();
  },[])
//====useEffect end here====

  return (
    <div className="eval_notifisStart_cover" >
    { //only the user with the create_evaluations permission should fire the evaluate system
        (evalNotifiSemiAnnualStart && checkPermissionAndThrow("create_evaluations") ) &&
        (
            <MainPageNotifiEvalStart 
            notifText={"حان موعد التقييم النصف سنوي اضغط ابدء للبدء و الانتقال الى صفحة الاحصائيات"}
            btnText = {"ابدء"}
            btnLink = {`${apiUrl}/evaluations/start-all`}
            navLink = {"/emp/eval_stat_main_page_show"}
            commingError = {error}
            />
        )
    }

{//only the user with the create_manager_evaluations permission should fire the evaluate system
        (evalNotifiDirectManagerStart && checkPermissionAndThrow("create_manager_evaluations") ) &&
        (
            <MainPageNotifiEvalStart 
            notifText={"حان موعد التقييم السنوي للمدير المباشر اضغط ابدء للبدء و الانتقال الى صفحة الاحصائيات"}
            btnText = {"ابدء"}
            btnLink = {`${apiUrl}/manager-evaluations/start-all`}
            navLink = {"/emp/eval_directManager_stat"}
            commingError = {error}
            />
        )
    }

    </div>
  )
}

export default ShowEvalResponsableEmpStartNotif